var TypeMessagesRMQ = {
  RaceChange: { name: "race-change" },
  EntryChange: { name: "entry-change" },
  RaceCreate: { name: "race-create" },
  EntryCreate: { name: "entry-create" },
  Pool: { name: "pool" },
  ResultCreate: { name: "result-create" },
  Packages: { name: "packages" },
};

export default TypeMessagesRMQ;
